<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent != null && localService.languageContent.edit_system_info != undefined">
  <app-popup-header title="{{localService.languageContent.edit_system_info.header}}"></app-popup-header>
  <div class="modal-body">
    <div *ngIf="wrapper">
      <div class="row">
        <label style="font-weight: normal; padding-left: 30px;">
          <input type="checkbox" [(ngModel)]="isActive" />
          <span class="normal_color">{{localService.languageContent.common.is_active}}</span>
        </label>
      </div>
      <div class="row">
        <label style="font-weight: normal; padding-left: 30px;">
          <input type="checkbox" [(ngModel)]="isResetPassword" />
          <span class="normal_color">{{localService.languageContent.edit_system_info.is_pwd_change_required}}</span>
        </label>
      </div>
      <div class="row">
        <label style="font-weight: normal; padding-left: 30px;">
          <input type="checkbox" [(ngModel)]="isBlock" [disabled]="blockPerStatusWhileLoading" />
          <span class="normal_color">{{localService.languageContent.edit_system_info.is_blocked}}</span>
        </label>
      </div>
      <div class="row">
        <label style="font-weight: normal; padding-left: 30px;">
          <input type="checkbox" [(ngModel)]="isPermenentBlock" [disabled]="blockPerStatusWhileLoading"
            (change)="onClick(1)" />
          <span class="normal_color">{{localService.languageContent.edit_system_info.is_per_blocked}}</span>
        </label>
      </div>
      <div class="row" *ngIf="isBlock != blockStatusWhileLoading">
        <textarea rows="3" [(ngModel)]="reason"
          placeholder="{{localService.languageContent.edit_system_info.reason_for_block_unblock}}"
          title="{{localService.languageContent.edit_system_info.reason_for_block_unblock}}"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer modal_footer_message" *ngIf="message != ''">
    <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
  </div>
  <div class="modal-footer">
    <div class="row" style="width: 100%;">
      <div class="col-6">
        <button type="button" class="btn btn-primary" style="background-color: red !important;"
        (click)="onForceLogOut()">{{localService.languageContent.common.logout}}</button>
      </div>
      <div class="col-6" style="text-align: right;">
        <button type="button" class="btn btn-primary"
        (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
      </div>
    </div>    
  </div>
</div>